import React from 'react';
import {
  MY_BRIEF_STATUSES,
  MY_BRIEF_SORT_OPTIONS,
  MY_BRIEF_DATE_RANGES,
  MY_BRIEF_CONTENT_TYPES,
  formatStatusLabel,
} from './myBriefsUtils';

function MyBriefsFilters({
  isAdmin,
  ownerLabel,
  draftSearch,
  onDraftSearchChange,
  onSearchSubmit,
  onClearDraft,
  filters,
  languages,
  owners = [],
  onFilterChange,
  onReset,
}) {
  const pageTitle = isAdmin
    ? (filters.ownerId === 'mine' ? 'My Drafts' : `${ownerLabel || 'Owner'} Drafts`)
    : 'My Drafts';

  return (
    <div className="my-briefs-filters-wrap">
      <div className="my-briefs-filters-top-row">
        <h1 className="my-briefs-page-title">{pageTitle}</h1>
      </div>

      {/* Admin sees one extra select (Owner). The row is flex-wrapped, so the
          count no longer needs a matching CSS variant. */}
      <div className="my-briefs-filters-grid">
        <form className="my-briefs-search-form my-briefs-filter-control" onSubmit={onSearchSubmit}>
          <input
            type="text"
            value={draftSearch}
            onChange={(event) => onDraftSearchChange(event.target.value)}
            placeholder="Search title or draft content"
            className="my-briefs-search-input"
          />
          <button
            type="button"
            className="my-briefs-search-clear"
            onClick={onClearDraft}
            disabled={!draftSearch}
            aria-label="Clear search"
          >
            X
          </button>
        </form>

        {isAdmin ? (
          <select
            value={filters.ownerId}
            onChange={(event) => onFilterChange('ownerId', event.target.value)}
            className="my-briefs-filter-select my-briefs-filter-control"
            aria-label="Owner"
          >
            <option value="mine">My drafts</option>
            {owners.map((owner) => (
              <option key={owner.userId} value={owner.userId}>{owner.label}</option>
            ))}
          </select>
        ) : null}

        <select
          value={filters.status}
          onChange={(event) => onFilterChange('status', event.target.value)}
          className="my-briefs-filter-select my-briefs-filter-control"
        >
          <option value="">Default</option>
          {MY_BRIEF_STATUSES.map((status) => (
            <option key={status} value={status}>{formatStatusLabel(status)}</option>
          ))}
        </select>

        <select
          value={filters.contentType || ''}
          onChange={(event) => onFilterChange('contentType', event.target.value)}
          className="my-briefs-filter-select my-briefs-filter-control"
          aria-label="Content type"
        >
          {MY_BRIEF_CONTENT_TYPES.map((option) => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>

        <select
          value={filters.language}
          onChange={(event) => onFilterChange('language', event.target.value)}
          className="my-briefs-filter-select my-briefs-filter-control"
        >
          <option value="">All languages</option>
          {languages.map((language) => (
            <option key={language} value={language}>{language}</option>
          ))}
        </select>

        <select
          value={filters.dateRange}
          onChange={(event) => onFilterChange('dateRange', event.target.value)}
          className="my-briefs-filter-select my-briefs-filter-control"
        >
          {MY_BRIEF_DATE_RANGES.map((option) => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>

        <select
          value={filters.sort}
          onChange={(event) => onFilterChange('sort', event.target.value)}
          className="my-briefs-filter-select my-briefs-filter-control"
        >
          {MY_BRIEF_SORT_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>

        <button type="button" className="my-briefs-reset-button my-briefs-filter-control" onClick={onReset}>
          Reset
        </button>
      </div>
    </div>
  );
}

export default MyBriefsFilters;
